import { isDefined as o } from "@scalar/helpers/array/is-defined";
import { encode as s } from "js-base64";
const p = (t) => t.flatMap((r) => r.type === "apiKey" ? r["x-scalar-secret-token"] : (r == null ? void 0 : r.type) === "http" ? [
  r["x-scalar-secret-token"],
  r["x-scalar-secret-username"],
  r["x-scalar-secret-password"],
  s(`${r["x-scalar-secret-username"]}:${r["x-scalar-secret-password"]}`)
] : r.type === "oauth2" ? Object.values(r.flows).map((a) => a["x-scalar-secret-token"]) : []).filter(o);
export {
  p as getSecrets
};
